// extracted by mini-css-extract-plugin
module.exports = {"description":"InformationPopup_description__3ODW5"};